import { useNavigate, useParams } from "react-router-dom";
import { useDashboardSurveyList } from "./useDashboardSurveyList";
import SurveyCard from "./survey-card.component";
import SurveyGroupCard from "./survey-group-card.component";
import { Survey } from "../../../redux/survey/survey.types";
import DashboardSurveyToolbar from "./dashboard-survey-toolbar";
import DashboardSurveyPagination from "./dashboard-survey-pagination.component";
import DashboardSurveyListEmpty from "./dashboard-survey-list-empty.component";
import { buildSurveyGroupResultsPath } from "../utils/survey-group-results-navigation";
import type { SurveyGroup } from "src/types/survey-group.types";

const DashboardSurveyList = ({ onSurveyAction }: { onSurveyAction: (survey: Survey, action: 'assign-client') => void }) => {
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId?: string }>();
  const { listRows, isListEmpty } = useDashboardSurveyList();

  const goGroupResults = (g: SurveyGroup) => {
    navigate(buildSurveyGroupResultsPath(g, clientId));
  };

  const renderCards = () => {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full" >
        {listRows.map((row, index) => {
          if (row.kind === 'group') {
            return (
              <SurveyGroupCard
                key={row.group ? `g-${row.group.id}` : `g-${index}`}
                group={row.group}
                index={index}
                onOpen={row.group ? () => goGroupResults(row.group) : undefined}
              />
            );
          }
          return (
            <SurveyCard
              survey={row.survey}
              key={row.survey?.extSurveyId ?? `s-${index}`}
              index={index}
              onSurveyAction={onSurveyAction}
            />
          );
        })}
      </div>
    );
  };

  return (
    <div
      className="flex flex-col gap-6 grow"
      id="survey-list"
    >
      <DashboardSurveyToolbar />
      {isListEmpty ? <DashboardSurveyListEmpty /> : renderCards()}
      <DashboardSurveyPagination />
    </div>
  );
};

export default DashboardSurveyList;
